import React from "react";
import { FormattedMessage } from "react-intl";
import { Row, Col } from "reactstrap";
import moment from "moment";
import { displayUsername } from "../../../../helpers/displayUsername";
import { ORGANIZATION_STATUSES, TRANSLATED_PACKAGE_STATUSES, TRANSLATED_SIGNING_TYPES, USER_STATUSES } from "../../../../config/constants";
import { ROUTE_CLIENT_ORGANIZATIONS_VIEW, ROUTE_CLIENT_USER_VIEW } from "../../../../config/routes";
import { LinkResource } from "../../../../components/shared/LinkResource";

function PackageDetailsSection(props) {
  const { packageDetails } = props;
  
  if (!packageDetails || !packageDetails.id) {
    return (
      <>
        <h6 className="heading-small">
          <FormattedMessage id="pages.documents.sections.packageDetailsSection.information" />
        </h6>
        <Row>
          <Col className="col-4 mt-3">
            <FormattedMessage id="messages.no_data" />
          </Col>
        </Row>
      </>
    );
  }

  return (
    <>
      <h6 className="heading-small">
        <FormattedMessage id="pages.documents.sections.packageDetailsSection.information" />
      </h6>
      <Row className="ml-lg-n3 mr-lg-n3 m-0">
        <Col className="col-auto mt-3 col-lg-6 p-0 p-lg-3 table-responsive">
          <table className="table-bordered table-striped table">
            <tbody>
              <tr>
                <th className="text-nowrap" scope="row">
                  <FormattedMessage id="pages.documents.sections.packageDetailsSection.package_id" />
                </th>
                <td>{packageDetails.id}</td>
              </tr>
              <tr>
                <th className="text-nowrap" scope="row">
                  <FormattedMessage id="pages.documents.sections.packageDetailsSection.package_created_at" />
                </th>
                <td>{moment(packageDetails.created_at).format("lll")}</td>
              </tr>
              <tr>
                <th className="text-nowrap" scope="row">
                  <FormattedMessage id="pages.documents.sections.packageDetailsSection.package_name" />
                </th>
                <td>{packageDetails.name}</td>
              </tr>
              <tr>
                <th className="text-nowrap" scope="row">
                  <FormattedMessage id="pages.documents.sections.packageDetailsSection.package_group_name" />
                </th>
                <td>{packageDetails.package_group.name}</td>
              </tr>
            </tbody>
          </table>
        </Col>
        <Col className="col-auto mt-3 col-lg-6 p-0 p-lg-3 table-responsive">
          <table className="table-bordered table-striped table">
            <tbody>
              <tr>
                <th className="text-nowrap" scope="row">
                  <FormattedMessage id="pages.documents.sections.packageDetailsSection.package_organization_name" />
                </th>
                <td>
                  {
                    packageDetails.organization?.id && packageDetails.organization?.status === ORGANIZATION_STATUSES.CREATED ?
                    <LinkResource
                      displayText={packageDetails.organization.name}
                      resourceLink={ROUTE_CLIENT_ORGANIZATIONS_VIEW}
                      resourceParamId={{':organizationId': packageDetails.organization.id}} 
                    /> :
                    <FormattedMessage id="components.pages.organizations.table.tableRow.organization_deleted" />
                  }
                </td>
              </tr>
              <tr>
                <th className="text-nowrap" scope="row">
                  <FormattedMessage id="pages.documents.sections.packageDetailsSection.package_user_name" />
                </th>
                <td>
                  {
                    packageDetails.user?.id && packageDetails.user?.status === USER_STATUSES.ACTIVE ? 
                    <LinkResource
                      displayText={displayUsername(packageDetails.user)}
                      resourceLink={ROUTE_CLIENT_USER_VIEW}
                      resourceParamId={{':userId': packageDetails.user.id}}
                    /> :
                    <FormattedMessage id="components.pages.organizations.table.tableRow.user_deleted" />
                  }
                </td>
              </tr>
              <tr>
                <th className="text-nowrap" scope="row">
                  <FormattedMessage id="pages.documents.sections.packageDetailsSection.package_status" />
                </th>
                <td>
                  {TRANSLATED_PACKAGE_STATUSES[packageDetails.status]}
                  {` (${packageDetails.status})`} -{" "}
                  {moment(packageDetails.updated_at).format("lll")}{" "}
                </td>
              </tr>
              <tr>
                <th className="text-nowrap" scope="row">
                  <FormattedMessage id="pages.documents.sections.packageDetailsSection.package_signing_type" />
                </th>
                <td>
                  {TRANSLATED_SIGNING_TYPES[packageDetails.signing_type]}
                </td>
              </tr>
            </tbody>
          </table>
        </Col>
      </Row>
    </>
  );
}

export { PackageDetailsSection };
